import t from 'tcomb';
import querystring from 'querystring';


const QueryString = t.union([t.String, t.Object], 'QueryString');

export default function to_url(url: t.String, qs: ?QueryString): t.String {

  qs = t.Obj.is(qs) ?
    querystring.stringify(qs) :
    qs || '';

  if (qs) {
    // è già presente il ?
    if (url.indexOf('?') !== -1) {
      url += '&' + qs;
    }
    else {
      // è presente un hash?
      var hashIndex = url.indexOf('#');
      if (hashIndex !== -1) {
        var hash = url.substring(hashIndex);
        url = url.substring(0, hashIndex) + '?' + qs + hash;
      }
      else {
        url += '?' + qs;
      }
    }
  }

  return url;
}


/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/domain/toUrl.js
 **/